exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2bpxG-CYoo5azKJr0Qkfpm{height:16px}._3VYlcZsPMUtI_LH2h36LNJ{cursor:pointer;white-space:nowrap;text-decoration:none}._1A_1kn9P3P7MHmxoq2qOdJ{font-weight:600}._18cJShnxyrDSPEijIqMK5a:after{content:\" \"}", ""]);
// Exports
exports.locals = {
	"recipientRowIcon": "_2bpxG-CYoo5azKJr0Qkfpm",
	"link": "_3VYlcZsPMUtI_LH2h36LNJ",
	"recipientName": "_1A_1kn9P3P7MHmxoq2qOdJ",
	"blankSpaceAfter": "_18cJShnxyrDSPEijIqMK5a"
};